export const MAPBOX_GL_TOKEN =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

export const MONITORED_URL =
  'https://caltimes-wildfires-data-service-dev.s3-us-west-2.amazonaws.com/pge/psps/monitored/2019-11-20/latest.json';

export const OUTAGES_URL =
  'https://caltimes-wildfires-data-service-dev.s3-us-west-2.amazonaws.com/pge/psps/outages/latest.json';

export const SUMMARY_URL =
  'https://caltimes-wildfires-data-service-dev.s3-us-west-2.amazonaws.com/pge/psps/outages-summary/latest.json';
